import { inject, Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter, map } from "rxjs/operators";
import { PolicyType } from "../enums/policy-type.enum";
import { RoutingPaths } from "../enums/routing-paths.enum";
import { toSignal } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: "root",
})
export class PolicyStore {
  private router = inject(Router);

  currentPolicyType$ = toSignal(this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((event) => this.extractPolicyType(event.urlAfterRedirects)),
  ))

  get currentPolicyType(): PolicyType | null {
    return this.extractPolicyType(this.router.url);
  }

  extractPolicyType(url: string): PolicyType | null {
    if (url.startsWith(`/${RoutingPaths.scb}/${RoutingPaths.myhome}`)) {
      return PolicyType.MyHome;
    } else if (url.startsWith(`/${RoutingPaths.scb}/${RoutingPaths.myhealth}`)) {
      return PolicyType.MyHealth;
    } else if (url.startsWith(`/${RoutingPaths.scb}/${RoutingPaths.remote}`)) {
      return PolicyType.Remote;
    }

    return null;
  }
}
